var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 125.27307,
    height: 125.27307,
    viewBox: "0 0 125.27307 125.27307",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,125.27307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(69.2056,37.6553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 2.521 C 3.728,0 4.71,0.982 4.71,2.189 v 28.065 c 0,1.208 -0.982,2.19 -2.189,2.19 H 0 c -1.207,0 -2.189,-0.982 -2.189,-2.19 V 2.189 C -2.189,0.982 -1.207,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(22.0154,65.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 1.242,2.754 3.289,4.993 5.92,6.475 2.117,1.191 4.455,1.804 6.845,1.804 0.587,0 1.176,-0.037 1.767,-0.111 2.335,-0.294 3.975,-1.329 5.711,-2.425 1.293,-0.816 2.758,-1.741 4.855,-2.568 1.811,-0.715 2.801,-0.206 3.389,0.239 0.678,0.513 1.086,1.199 1.215,1.437 0.325,1.046 1.3,1.806 2.453,1.806 1.419,0 2.569,-1.15 2.569,-2.569 0,-0.454 -0.118,-0.88 -0.325,-1.25 0,0 -0.855,-1.936 -2.567,-3.329 -2.408,-1.962 -5.47,-2.357 -8.621,-1.114 C 20.666,-0.6 18.911,0.508 17.5,1.399 15.918,2.398 15.038,2.926 13.891,3.07 10.001,3.557 6.302,1.476 4.684,-2.112 l -9.772,-21.674 c -0.38,-0.843 -0.319,-1.777 0.167,-2.563 0.485,-0.784 1.291,-1.256 2.212,-1.295 l 17.327,-0.592 c 1.5,-0.06 2.892,-0.773 3.818,-1.955 0.926,-1.181 1.284,-2.703 0.983,-4.174 -1.475,-7.2 -1.515,-11.15 -1.061,-12.446 0.498,-1.42 2.064,-2.231 3.275,-2.659 1.989,5.511 6.336,17.36 8.996,23.142 1.404,3.053 3.384,4.914 5.885,5.532 1.204,0.297 2.345,0.251 3.349,0.048 v 22.72 c 0,4.041 3.287,7.328 7.327,7.328 h 2.521 c 4.041,0 7.328,-3.287 7.328,-7.328 v -28.065 c 0,-4.04 -3.287,-7.327 -7.328,-7.327 H 47.19 c -4.024,0 -7.3,3.261 -7.326,7.28 -0.554,0.267 -1.376,0.547 -2.139,0.35 -1.119,-0.289 -1.938,-1.619 -2.428,-2.685 -2.768,-6.016 -7.645,-19.441 -9.073,-23.413 -0.776,-2.155 -3.11,-3.358 -5.314,-2.739 -3.761,1.057 -6.389,3.229 -7.401,6.117 -0.933,2.663 -0.641,7.757 0.869,15.141 l -17.287,0.591 c -2.618,0.105 -5.005,1.498 -6.383,3.728 -1.378,2.229 -1.557,4.986 -0.48,7.375 z m 24.962,-65.938 c 25.945,0 46.977,21.033 46.977,46.978 0,25.945 -21.032,46.977 -46.977,46.977 -25.945,0 -46.977,-21.032 -46.977,-46.977 0,-25.945 21.032,-46.978 46.977,-46.978",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/Thumbs-down.fb58b2743560cf7c5f8203b472904784.svg";
export { ForwardRef as ReactComponent };